import UIObject from '../common/dynamic-form/UIObject'
import { InputField, INPUT_TYPE } from '../common/dynamic-form/InputField'
import React from 'react';
import { Form, Select } from 'antd';
import { Timestamp } from 'firebase/firestore';
import dayjs from 'dayjs';
import { validatePhoneNumber } from '../common/Converter';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { dateFormatList } from '../common/dynamic-form/items/BaseInputItem';
import { useSchool } from '../hook/SchoolHook';

dayjs.extend(customParseFormat);

export interface ICustomer {
    name: string,
    nameFather?: string,
    nameMother?: string,
    userId: string,
    maHs?: string,
    phoneFather?: string,
    phoneMother?: string,
    password?: string,
    level?: number,
    status: number,
    source?: string,
    expired: Timestamp,
    birthday?: Timestamp,
    school:string,
    class:string,
    age?:number,
    // district?:string,
    address?:string,
    listUserIds?:Array<string>
}

export const CUSTOMER_STATUS = Object.freeze({
    ACTIVE: { key: 1, label: "Hoạt động" },
    DISABLED: { key: 0, label: "Đã ngừng" },
    DRAFT: { key: 2, label: "Chờ xác minh" },
    EXPIRED: { key: 3, label: "Đã quá hạn" },
    BLOCKED: { key: 4, label: "Bị khóa" },
})
export const CUSTOMER_SOURCE = Object.freeze({
    IMPORT_FILE: { key: 1, label: "Import qua file" },
    MANUAL_INPUT: { key: 0, label: "Admin tự nhập tay" },
    CLIENT_APP: { key: 2, label: "Tự đăng ký trên App" },
})
export const statusColor = (status:number)=>{
    switch(status) {
        case CUSTOMER_STATUS.ACTIVE.key: return "green";break;
        case CUSTOMER_STATUS.DISABLED.key: return "gray";break;
        case CUSTOMER_STATUS.DRAFT.key: return "cyan";break;
        case CUSTOMER_STATUS.EXPIRED.key: return "orange";break;
        case CUSTOMER_STATUS.BLOCKED.key: return "red";break;
        default: return "black";
    }
}

const prefixSelector = (
    <Form.Item noStyle>
        <Select style={{ width: 70 }} defaultValue='+84'>
            <Select.Option value="+84">+84</Select.Option>
        </Select>
    </Form.Item>
);


export default class CustomerObject extends UIObject {

    constructor(data: ICustomer) {
        super(data);

        this.updateFieldProperties(new InputField({
            key: "maHs",
            label: "Mã học sinh ",
            value: data.maHs,
            extra: {
                props: { placeholder: "Nhập mã của Học Sinh này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 0)
        const school = new InputField({
            key: "school",
            label: "Mã Trường học",
            
            required: true,
            value: data.school,
            extra: {
                props: { placeholder: "Nhập mã trường học của học sinh này..." },
            }
        });
        // const status = new InputField({ key: "status", label: "Trạng thái người dùng", value: data.status, required: true, extra: { props: { placeholder: "Hãy chọn một trạng thái", require_message: "Trạng thái của người dùng là bắt buộc" } } });
        // let listSchool: any[] = [];
        // school.convertToSelect(listSchool);
        this.updateFieldProperties(school, 1)

        this.updateFieldProperties(new InputField({
            key: "class",
            label: "Tên lớp học",
            value: data.class,
            required: true,
            extra: {
                props: { placeholder: "Nhập tên lớp học của học sinh này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 2)

        this.updateFieldProperties(new InputField({
            key: "name",
            label: "Họ Tên học sinh ",
            value: data.name,
            required: true,
            extra: {
                props: { placeholder: "Nhập họ tên của học sinh này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 3)
        

        this.updateFieldProperties(new InputField({
            key: "nameFather",
            label: "Tên Cha ",
            value: data.nameFather,
            extra: {
                props: { placeholder: "Nhập tên cha của học sinh này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 5)
        this.updateFieldProperties(new InputField({
            key: "phoneFather",
            label: "Số điện thoại Cha",
            value: data.phoneFather,
            required: false,
            extra: {
                props: { placeholder: "Nhập Số điện thoại cha của người dùng...", addonBefore: prefixSelector },
                // require_message: "Số điện thoại là bắt buộc",
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                        // required: true,
                        // message: "Không được để trống số điện thoại"
                    }
                    ,{
                        max: 12,
                        min: 9,
                        message: "Số điện thoại phải có từ 9 đến 12 ký tự"
                    },
                    {
                        validator: (_: any, value: any) => validatePhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Không đúng định dạng số điện thoại. Hãy kiểm tra lại!'))
                    }
                ]
            }
        }), 6)


        this.updateFieldProperties(new InputField({
            key: "nameMother",
            label: "Tên Mẹ ",
            value: data.nameMother,
            extra: {
                props: { placeholder: "Nhập tên mẹ của học sinh này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 7)
        this.updateFieldProperties(new InputField({
            key: "phoneMother",
            label: "Số điện thoại Mẹ",
            value: data.phoneMother,
            required: false,
            extra: {
                props: { placeholder: "Nhập Số điện thoại Mẹ của người dùng...", addonBefore: prefixSelector },
                // require_message: "Số điện thoại là bắt buộc",
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                        // required: true,
                        // message: "Không được để trống số điện thoại"
                    }
                    ,{
                        max: 12,
                        min: 9,
                        message: "Số điện thoại phải có từ 9 đến 12 ký tự"
                    },
                    {
                        validator: (_: any, value: any) => validatePhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Không đúng định dạng số điện thoại. Hãy kiểm tra lại!'))
                    }
                ]
            }
        }), 8)

        this.updateFieldProperties(new InputField({
            key: "userId",
            label: "Id đăng nhập ",
            required: true,
            value: data.userId,
            extra: {
                props: { placeholder: "Nhập Id đăng nhập trên game cho người dùng này..." },
                require_message: "Id đăng nhập là bắt buộc",
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                        required: true,
                        message: "Không được để Id đăng nhập"
                    }, 
                    {
                        validator: (_: any, value: any) => (value===data.userId || !data.listUserIds || (Array.isArray(data.listUserIds) && data.listUserIds.findIndex(l=>l===value)==-1)) ? Promise.resolve() : Promise.reject(new Error('Id đăng nhập này đã tồn tại trên hệ thống!'))
                    }
                ]
            }
        }), 9)
        this.updateFieldProperties(new InputField({
            key: "password",
            label: "Mật khẩu",
            required: true,
            value: data.password,
            extra: {
                props: { placeholder: "Nhập mật khẩu cho người dùng này..." },
                require_message: "Mật khẩu là bắt buộc",
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                        required: true,
                        message: "Không được để trống mật khẩu"
                    }
                ]
            }
        }), 10)


        this.updateFieldProperties(new InputField({
            key: "expired",
            label: "Ngày hết hạn",
            value: "",
            required: false,
            inputType: INPUT_TYPE.DATE,
            extra: {
                props: {
                    placeholder: "Tài khoản sẽ hết hạn vào ngày: ...",
                    format: dateFormatList,
                    minDate: dayjs(),
                    maxDate: dayjs("2900-01-01", "YYYY-MM-DD")
                },
                inputStyle: { width: "100%" },
                require_message: "Ngày hết hạn là bắt buộc",
            },
        }), 11)
        this.updateFieldProperties(new InputField({
            key: "birthday",
            label: "Ngày sinh",
            value: "",
            required: false,
            inputType: INPUT_TYPE.DATE,
            extra: {
                props: {
                    placeholder: "Ngày tháng năm sinh: ...",
                    format: dateFormatList,
                    minDate: dayjs("1900-01-01", "YYYY-MM-DD"),
                    maxDate: dayjs(),
                },
                inputStyle: { width: "100%" },
                // require_message: "Ngày hết hạn là bắt buộc",
            },
        }), 4)


        this.updateFieldProperties(new InputField({
            key: "address",
            label: "Địa chỉ ",
            value: data.address,
            extra: {
                props: { placeholder: "Nhập địa chỉ của người dùng này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 12)

        const status = new InputField({ key: "status", label: "Trạng thái người dùng", value: data.status, required: false, extra: { props: { placeholder: "Hãy chọn một trạng thái", require_message: "Trạng thái của người dùng là bắt buộc" } } });
        let types: any[] = [];
        Object.keys(CUSTOMER_STATUS).forEach(type => { types.push({ value: CUSTOMER_STATUS[type as keyof typeof CUSTOMER_STATUS].key, label: <span>{CUSTOMER_STATUS[type as keyof typeof CUSTOMER_STATUS].label}</span> }) })
        status.convertToSelect(types);
        this.updateFieldProperties(status, 13)
        
        const source = new InputField({ key: "source", label: "Nguồn gốc của tài khoản", value: data.source, extra:{props:{}}});
        let sources: any[] = [];
        Object.keys(CUSTOMER_SOURCE).forEach(type => { sources.push({ value: CUSTOMER_SOURCE[type as keyof typeof CUSTOMER_SOURCE].key, label: <span>{CUSTOMER_SOURCE[type as keyof typeof CUSTOMER_SOURCE].label}</span> }) })
        source.convertToSelect(sources);
        this.updateFieldProperties(source, 14)

        this.updateFieldProperties(new InputField({
            key: "age",
            label: "Tuổi ",
            value: data.address,
            inputType:INPUT_TYPE.NUMBER,
            extra: {
                props: { placeholder: "Nhập tuổi của người dùng này..." },
                rules: [
                    {
                        type: "number",
                        whitespace: true,
                    }
                ]
            }
        }), 15)

        // this.updateFieldProperties(new InputField({
        //     key: "phone",
        //     label: "Số điện thoại ",
        //     value: data.phone,
        //     required: true,
        //     extra: {
        //         props: { placeholder: "Nhập Số điện thoại của người dùng...", addonBefore: prefixSelector },
        //         require_message: "Số điện thoại là bắt buộc",
        //         rules: [
        //             {
        //                 type: "string",
        //                 whitespace: true,
        //                 required: true,
        //                 message: "Không được để trống số điện thoại"
        //             }
        //             ,{
        //                 max: 12,
        //                 min: 9
        //             },
        //             {
        //                 validator: (_: any, value: any) => validatePhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Không đúng định dạng số điện thoại. Hãy kiểm tra lại!'))
        //             }
        //         ]
        //     }
        // }), 0)

        // this.updateFieldProperties(new InputField({
        //     key: "class",
        //     label: "Lớp ",
        //     value: data.class,
        //     extra: {
        //         props: { placeholder: "Nhập lớp học của người dùng này..." },
        //         rules: [
        //             {
        //                 type: "string",
        //                 whitespace: true,
        //             }
        //         ]
        //     }
        // }), 7)
        // this.updateFieldProperties(new InputField({
        //     key: "district",
        //     label: "Quận/Huyện ",
        //     value: data.district,
        //     extra: {
        //         props: { placeholder: "Nhập quận huyện nơi người dùng ở..." },
        //         rules: [
        //             {
        //                 type: "string",
        //                 whitespace: true,
        //             }
        //         ]
        //     }
        // }), 8)
        this.addHiddenField("listUserIds");
        this.addLockedField(source.key);
        this.addHiddenField("schoolData");
        this.mapData();
    }
}
